import { layoutTypes } from './layout.types';

export const setLoading = (flag: boolean) => ({
  type: layoutTypes.LOADING,
  payload: flag,
});

export const setLoadingTable = (flag: boolean) => ({
  type: layoutTypes.LOADING_TABLE,
  payload: flag,
});

export const setLoadingUpdateUser = (flag: boolean) => ({
  type: layoutTypes.LOADING_UPDATE_USER,
  payload: flag,
  isUser: flag,
});

export const setIsMobile = (flag: boolean) => ({
  type: layoutTypes.IS_MOBILE,
  payload: flag,
});
